import React, { useEffect, useState } from 'react'
import { IconButton, styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '../../components/StyledButtons';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';
import { ToastContainer, toast } from 'react-toastify';
import instance from '../../axios/axiosConfig';
import LoadingSpinner from '../../components/LoadingSpinner';

const ModalPricingCloudPlans = ({ setOpenModal, handleOverlayClick, modalRef }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isValid, setIsValid] = useState(false)

    const successNotify = () => toast.success(t('notifycation.success'), {
        position: "bottom-right"
    });

    const failedNotify = () => toast.error(t('notifycation.failed'), {
        position: "bottom-right"
    });

    useEffect(() => {
        if (isLoading === true) {
            document.body.style.overflow = "hidden";
        }
        else {
            document.body.style.overflow = "auto";
        }
    }, [isLoading])

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        website: '',
        phoneNumber: '',
        message: ''
    });

    const [validationMessages, setValidationMessages] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
    });

    useEffect(() => {
        const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
        const { fullName, email, phoneNumber } = formData;
        const isFullNameValid = fullName.trim() !== '';
        const isPhoneNumberValid = phoneNumber.trim() === "" || phoneRegex.test(phoneNumber.trim())
        const isEmailValid = email.trim() !== '';
        const isFormDataValid = isFullNameValid && isEmailValid && isPhoneNumberValid;
        const isValidationMessagesEmpty = Object.values(validationMessages).every(message => message === '');
        if (isFormDataValid && isValidationMessagesEmpty) {
            setIsValid(true)
        }
        else {
            setIsValid(false)
        }
        // if(Object.values(formData).every((value) => value !== '') &&
        // Object.values(validationMessages).every((message) => message === '')){
        //   setIsValid(true)
        // }
        // else{
        //   setIsValid(false)
        // }
    }, [formData, validationMessages])

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'fullName') {
            setValidationMessages((prevMessages) => ({
                ...prevMessages,
                fullName: value.trim() === '' ? t('validation.full-name-required') : '',
            }));
        }

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value.trim() === "") {
                setValidationMessages(prevMessages => ({
                    ...prevMessages,
                    email: t('validation.email-required')
                }));
            } else if (!emailRegex.test(value.trim())) {
                setValidationMessages(prevMessages => ({
                    ...prevMessages,
                    email: t('validation.email-invalid')
                }));
            } else {
                setValidationMessages(prevMessages => ({
                    ...prevMessages,
                    email: ''
                }));
            }
        }

        if (name === 'phoneNumber') {
            const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
            setValidationMessages((prevMessages) => ({
                ...prevMessages,
                phoneNumber: value.trim() === "" || phoneRegex.test(value.trim()) ? '' : t('validation.phone-invalid'),
            }));
        }
    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\+?84\s*[0-9]{4,}$|^[0-9]{6,}$/;
        const newValidationMessages = {
            fullName: '',
            email: '',
            phoneNumber: '',
        };

        if (!formData.fullName.trim()) {
            newValidationMessages.fullName = t('validation.full-name-required');
        }

        if (!formData.email.trim()) {
            newValidationMessages.email = t('validation.email-required');
        } else if (!emailRegex.test(formData.email.trim())) {
            newValidationMessages.email = t('validation.email-invalid');
        }

        if (formData.phoneNumber.trim() !== "") {
            if (!phoneRegex.test(formData.phoneNumber.trim())) {
                newValidationMessages.phoneNumber = t('validation.phone-invalid');
            }
        }

        setValidationMessages(newValidationMessages);
        console.log("Ater", newValidationMessages)
        console.log(!Object.values(newValidationMessages).some((msg) => msg !== ''))
        if (!Object.values(newValidationMessages).some((msg) => msg !== '')) {
            const data = {
                fullName: formData.fullName,
                email: formData.email,
                message: formData.message,
                phoneNumber: formData.phoneNumber,
                website: formData.website,
                type: "Pricing Cloud Plans Usage Based"
            };

            try {
                setIsLoading(true)
                console.log("Data", data)
                await instance.post('/sendContact', data)
                    .then(function (response) {
                        if (response.data === "success") {
                            setIsLoading(false)
                            successNotify()
                            setFormData({
                                fullName: '',
                                email: '',
                                message: '',
                                website: '',
                                phoneNumber: ''
                            })
                            setValidationMessages({
                                fullName: '',
                                email: '',
                                phoneNumber: '',
                            })
                            newValidationMessages.email = ""
                            newValidationMessages.fullName = ""
                            newValidationMessages.phone = ""

                        }
                        else {
                            setIsLoading(false)
                            failedNotify()

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        setIsLoading(false)
                        failedNotify()

                    });

            } catch (error) {
                console.error('Error:', error);
                setIsLoading(false)
                failedNotify()
            } finally {
                setIsLoading(false)
                // setOpenModal(false)
            }
        }
    }




    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const CloseButton = styled(IconButton)({
        padding: "4px",
        backgroundColor: 'rgba(1, 13, 22, 0.6)',
        color: '#FFF',
        '&:hover': {
            backgroundColor: 'rgba(1, 13, 22, 0.6)',
        },
    })

    return (
        <div className='modal-contact-form_overlay' onClick={handleOverlayClick}>
            <div className='modal-contact-form_container' id="modal-contact-form" ref={modalRef}>
                <div className='modal-contact-form_closeButton'>
                    <CloseButton onClick={() => { setOpenModal(false) }}>
                        <Close />
                    </CloseButton>
                </div>
                <div className="modal-contact-form_body pt-30">
                    <div className='col-sm-12'>
                        {language === "en"
                            ?
                            <p className='font-weight-semi-bold font-28'>Find out more about Qrypto <span className='text-primary-orange'>Usage Based</span> Pricing</p>
                            :
                            <p className='font-weight-semi-bold font-28'>Tìm hiểu thêm về Định giá dựa trên <span className='text-primary-orange'>mức sử dụng</span> của Qrypto</p>
                        }
                        <p className='pt-20'>{t('modal.cloud-plans-form.description-1')}</p>

                    </div>
                    <form className='pt-30 col-sm-12' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-sm-12 col-md-6'>
                                <div className='form-group'>
                                    <p className='font-weight-medium'>{t('modal.default-form.full-name')}
                                        &nbsp;
                                        <span style={{ color: "#D8513F" }}>*</span>
                                    </p>
                                    <input className="form-control"
                                        placeholder='John Carter'
                                        type="text"
                                        name="fullName"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                    />
                                    {validationMessages.fullName && <div className="errors--label">{validationMessages.fullName}</div>}
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <div className='form-group'>
                                    <p className='font-weight-medium'>{t('modal.default-form.phone-number')}&nbsp;
                                        {/* <span style={{ color: "#D8513F" }}>*</span> */}
                                    </p>
                                    <input className="form-control"
                                        type="text"
                                        placeholder='+84937776642'
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                    />
                                    {validationMessages.phoneNumber && <div className="errors--label">{validationMessages.phoneNumber}</div>}
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <div className='form-group'>
                                    <p className='font-weight-medium'>Email&nbsp;
                                        <span style={{ color: "#D8513F" }}>*</span>
                                    </p>
                                    <input className="form-control"
                                        type='email'
                                        placeholder='example@gmail.com'
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                    {validationMessages.email && <div className="errors--label">{validationMessages.email}</div>}
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6'>
                                <div className='form-group'>
                                    <p className='font-weight-medium'>{t('modal.default-form.organization-website')}&nbsp;
                                        {/* <span className='plus-red'>+</span> */}
                                    </p>
                                    <input className="form-control"
                                    type="text"
                                    placeholder='https://www.mobile-id.vn/'
                                    name="website"
                                    value={formData.website}
                                    onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <p className='pt-20 pb-20 italic'>{t('modal.cloud-plans-form.description-2')}</p>
                            </div>
                            <div className='col-sm-12'>
                                <div className='form-group'>
                                    <p className='font-weight-medium'>{t('modal.default-form.message')}&nbsp;
                                        {/* <span style={{ color: "#D8513F" }}>*</span> */}
                                    </p>
                                    <textarea style={{ resize: "vertical" }} className="form-control"
                                    type="text"
                                    placeholder={t('modal.default-form.type-message-here')}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}      
                                    />
                                </div>
                            </div>
                            <div className='col-sm-12 pt-20'>
                                <div className='form-group flex justify-center'>
                                    <PrimaryButton type='submit' disabled={!isValid}>{t('button.send-message')}</PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer />
            {isLoading && <LoadingSpinner />}
        </div>
    )
}

export default ModalPricingCloudPlans